<template>
<el-dialog class='wx_connection' title="绑定微信号" size="tiny" @close='close' :visible.sync="dialogVisible">
  <div class='content'>
    <img class='qrcode' :src="'//qrcode.ppj.io/'+wxConnection.url" />
    <p class='hint'>扫码绑定微信号</p>
  </div>

  <div class='footer' slot='footer'>
    <el-button type='primary' @click='close'>关闭</el-button>
  </div>
</el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false
    }
  },
  computed: {
    wxConnection() {
      return this.$store.state.user.wxConnection
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.$store.dispatch('user/wxConnection')
    },
    close() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang='scss' scoped>
.wx_connection {
    .content {
        text-align: center;
        padding-top: 20px;

        .qrcode {
            width: 180px;
            height: 180px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// wx_connection.dialog.vue?37ece61f